import type { SerializerTarget } from './serializer';

/**
  * SizeCalculator is an implementation of serialization target that does not
  * actually serializer anything, but rather just keeps track of the number of
  * bytes what would have been written. This is useful for calculating size of
  * something without the additional cost of actually serializing.
  */
export class SizeCalculator implements SerializerTarget {
  private offset : number = 0;
  writeByte(_: number) {
    this.offset += 1;
  }
  writeBytes(array: Uint8Array) {
    this.offset += array.length;
  }
  reset() {
    this.offset = 0;
  }
  size() {
    return this.offset;
  }
}
